import React, { useRef, useEffect, useState } from 'react';
import imageLogo from "../assets/logo_ticket_win.png";
import { MdFileDownload } from 'react-icons/md';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';

const ImageWithRect = ({ qrUrl, imageUrl, number, description, imageSrc, showPreviously, raffleId }) => {
  const canvasRef = useRef(null);
  const [imageDataUrl, setImageDataUrl] = useState(null);  // Estado para almacenar la URL del canvas si showPreviously es true

  const loadAndDrawImage = (imgSrc) => {
    const img = new Image();
    
    img.src = imgSrc;
  
    img.onload = () => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
  
      const headerHeight = 250; // Altura del rectángulo blanco superior
      canvas.width = img.width;
      canvas.height = img.height + headerHeight;
  
      // Dibujar el rectángulo blanco en la parte superior
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, img.width, headerHeight);
  
      // Dibujar la imagen debajo del rectángulo blanco
      ctx.drawImage(img, 0, headerHeight);
  
      // Estilos del texto para el encabezado
      ctx.fillStyle = 'black';
      ctx.font = 'bold 45px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
  
      const firstTextY = headerHeight / 2 - 30;
      ctx.fillText(description ? description : 'Nombre Apellido (123-456)', img.width / 2, firstTextY);
  
      // Texto secundario en rojo
      ctx.fillStyle = 'red';
      ctx.font = 'bold 45px Arial';
      const secondTextY = headerHeight / 2 + 30;
      ctx.fillText('No. ' + (number ? ((number < 10) ? `0${number}` : `${number}`) : "0000"), img.width / 2, secondTextY);
  
      // Cargar y dibujar el logo en la parte inferior izquierda
      const logoImg = new Image();
      logoImg.src = imageLogo;
      logoImg.onload = () => {
        const logoWidth = 200;
        const logoHeight = logoImg.height * (logoWidth / logoImg.width);
        ctx.drawImage(logoImg, 10, headerHeight - logoHeight - 10, logoWidth, logoHeight);
      };
  
      // Cargar y dibujar el código QR en la esquina inferior derecha
      const qrImg = new Image();
      qrImg.src = qrUrl;
      qrImg.onload = () => {
        ctx.drawImage(qrImg, canvas.width - qrImg.width - 10, canvas.height - qrImg.height - 10);
      };
  
      // Si showPreviously es true, almacenar la imagen como data URL
      if (showPreviously) {
        const dataUrl = canvas.toDataURL('image/png');
        setImageDataUrl(dataUrl);
      }
    };
  
    img.onerror = (error) => {
      console.error("Error al cargar la imagen:", error);
    };
  };

  const downloadCanvasAsImage = () => {
    const canvas = canvasRef.current;
    const link = document.createElement('a');
    
    link.href = canvas.toDataURL('image/png');
    link.download = `ticketwin-${number}.png`;
    link.click();
  };

  const convertImageToBase64 = async (url) => {
    try {
      const response = await fetch(url);
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
        
      const blob = await response.blob();
  
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = (error) => {
          console.error("FileReader error:", error);
          reject(error);
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error converting image to base64:', error);
      return undefined;
    }
  };
  

  useEffect(() => {
    const loadImage = async () => {
        // Verificar si imageUrl es una referencia en Firebase        
        if (imageUrl) {
          const publicUrl = await convertImageToBase64(imageUrl);
          
          loadAndDrawImage(publicUrl);

      } else if (imageSrc) {
        loadAndDrawImage(imageSrc);
      }
    };
  
    loadImage();
  }, [imageUrl, imageSrc, description]);

  return (
    <div>
      {(imageUrl || imageSrc) && (
        <button 
          onClick={downloadCanvasAsImage}
          className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-full inline-flex items-center"
        >
            <MdFileDownload size={20} />
        </button>
      )}

      {/* Mostrar la imagen previamente generada si showPreviously es true */}
      {showPreviously && imageDataUrl && (
        <div style={{ marginTop: '20px' }}>
          <img src={imageDataUrl} alt="Previsualización de la imagen generada" />
        </div>
      )}

      {/* Canvas oculto */}
      <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
    </div>
  );
};

export default ImageWithRect;
